export default __webpack_public_path__ + "static/media/bedroom5.9e9d45b1.webp";